module.exports = __webpack_public_path__ + "static/img/map-position.42eb86d7.svg";